/**
 *Created by Heqi on 2018/1/25.
 */

import { AbstractSearchArgument } from '.././global'
import { CONDITION_TYPE, DATE_PICKER_SHOW_TYPE } from '@/utils/constants'

const SEARCH_CONDITION = [
  {
    name: 'time',
    title: '创建时间',
    placeholder: '',
    type: CONDITION_TYPE.DATE,
    value: '',
    visible: true,
    config: {
      type: DATE_PICKER_SHOW_TYPE.DATE_RANGE,
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd'
    }
  },
  {
    name: 'itemId',
    title: '项目名称',
    placeholder: '请选择您的项目',
    type: CONDITION_TYPE.SELECT,
    value: '',
    visible: true,
    config: {
      list: []
    }
  },
  {
    name: 'readStatus',
    title: '是否已读',
    placeholder: '请选择',
    type: CONDITION_TYPE.SELECT,
    value: '',
    visible: true,
    config: {
      list: [
        {value: 1, label: '已读'},
        {value: 0, label: '未读'}
      ]
    }
  },
  {
    name: 'crmFollowerState',
    title: '接收人',
    placeholder: '请选择',
    type: CONDITION_TYPE.SELECT,
    value: '',
    visible: true,
    config: {
      list: [
        {value: 1, label: '有接收'},
        {value: 0, label: '未接收'}
      ]
    }
  },
  {
    name: 'phone',
    title: '手机号码',
    placeholder: '支持模糊查询',
    type: CONDITION_TYPE.TEXT,
    value: '',
    visible: true
  }
]

class SearchArgument extends AbstractSearchArgument {
  constructor () {
    super()

    this.startTime = ''
    this.endTime = ''
    this.itemId = ''
    this.readStatus = null
    this.crmFollowerState = null
    this.phone = ''
  }
}

class UserSearchArgument extends AbstractSearchArgument {
  constructor () {
    super()

    this.userName = ''
    this.sourceName = ''
  }
}

class FormArgument extends AbstractSearchArgument {
  constructor () {
    super()

    this.resourceList = []
    this.userId = ''
    this.channelSourceCode = ''
  }
}

export {
  SEARCH_CONDITION,
  SearchArgument,
  UserSearchArgument,
  FormArgument
}



// WEBPACK FOOTER //
// ./src/models/client/resource.js